<template>
  <div>
    <v-dialog v-model="show" persistent max-width="80%">
      <v-card>
        <v-card-title>
          <span class="text-h5">Editar Producto</span>
          <v-spacer></v-spacer>
          <v-btn icon color="#016CB3" @click="() => (show = false)">
            <v-icon color="#016CB3">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-container>
            <v-form autocomplete="off" @submit.prevent="onSubmit">
              <v-row>
                <v-col cols="12" sm="12" md="12" class="mt-0">
                  <v-text-field
                    v-model="formObj.name"
                    type="text"
                    label="Nombre"
                    placeholder=""
                    :error-messages="nameErrors"
                    @input="$v.formObj.name.$touch()"
                    @blur="$v.formObj.name.$touch()"
                  />
                </v-col>

                <v-col cols="12" sm="12" md="12" class="mt-n5">
                  <v-file-input
                    v-model="formObj.fileImg"
                    accept="image/png, image/jpeg, image/bmp"
                    placeholder=""
                    append-icon="mdi-camera"
                    prepend-icon=""
                    label="Imagen"
                    :error-messages="fileImgErrors"
                    @input="$v.formObj.fileImg.$touch()"
                    @blur="$v.formObj.fileImg.$touch()"
                  />
                  <div v-if="imgProfileView">
                    <v-img
                      :src="imgProfileView"
                      max-width="100px"
                      max-height="100px"
                      min-width="100px"
                      min-height="100px"
                      class="ml-0 mb-5"
                    ></v-img>
                  </div>
                </v-col>
                <v-col cols="12" sm="12" md="12" class="mt-n7">
                  <v-text-field
                    v-model="formObj.brand"
                    type="text"
                    label="Marca"
                    placeholder=""
                    :error-messages="brandErrors"
                    @input="$v.formObj.brand.$touch()"
                    @blur="$v.formObj.brand.$touch()"
                  />
                </v-col>

                <v-col cols="12" sm="12" md="12" class="mt-n7">
                  <v-text-field
                    type="text"
                    v-model="formObj.price"
                    label="Precio"
                    placeholder=""
                    v-on:keyup="inputSoloNumeroDecimal"
                    :error-messages="priceErrors"
                    @input="$v.formObj.price.$touch()"
                    @blur="$v.formObj.price.$touch()"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="12" class="mt-n7">
                  <v-text-field
                    type="text"
                    v-model="formObj.stock"
                    label="Stock"
                    placeholder=""
                    v-on:keyup="inputSoloNumero"
                    :error-messages="stockErrors"
                    @input="$v.formObj.stock.$touch()"
                    @blur="$v.formObj.stock.$touch()"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="12" md="12" class="mt-n5">
                  <v-select
                    v-model="formObj.id_category"
                    :items="itemsCategoria"
                    :error-messages="categoryErrors"
                    hide-no-data
                    hide-selected
                    placeholder=""
                    label="Categoria"
                    return-object
                    item-text="name"
                    item-value="id"
                    @input="$v.formObj.id_category.$touch()"
                    @blur="$v.formObj.id_category.$touch()"
                  />
                </v-col>

                <v-col cols="12" sm="12" md="12" class="mt-n5">
                  <v-select
                    v-model="formObj.id_sub_category"
                    :items="itemsSubCategoria"
                    :error-messages="subCategoryErrors"
                    hide-no-data
                    hide-selected
                    placeholder=""
                    label="Sub Categoria"
                    return-object
                    item-text="name"
                    item-value="id"
                    @input="$v.formObj.id_sub_category.$touch()"
                    @blur="$v.formObj.id_sub_category.$touch()"
                  />
                </v-col>

                <v-col cols="12" sm="12" md="12" class="mt-n5">
                  <v-textarea
                    v-model="formObj.descrition"
                    label="Descripción"
                    rows="2"
                    placeholder=""
                  />
                </v-col>
              </v-row>

              <div class="text-center">
                <v-btn
                  color="primary"
                  class="ma-2"
                  type="submit"
                  small
                  :loading="isLoading"
                >
                  Guardar
                </v-btn>
                <v-btn
                  color="primary"
                  class="ma-2"
                  small
                  @click.stop="show = false"
                  :loading="isLoading"
                >
                  Cancelar
                </v-btn>
              </div>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { validationMixin } from "vuelidate";
import Vue from "vue";
import {
  required,
  maxLength,
  numeric,
  requiredIf,
  decimal,
} from "vuelidate/lib/validators";

export default {
  name: "ModalEditProduct",
  components: {},
  filters: {
    moment(value) {
      return moment(value).format("DD/MM/YYYY");
    },
    num_format(value) {
      value = parseFloat(value);
      return numeral(value).format("0,0.00");
    },
  },
  mixins: [validationMixin],
  props: ["visible", "objEdit"],
  data() {
    return {
      imgProfileView: null,
      isLoading: false,
      modalTime1: false,
      modalTime2: false,
      dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      menu2: false,
      formObj: {
        id: "",
        name: "",
        brand: "",
        description: "",
        price: "",
        stock: "",
        fileImg: "",
        id_category: "",
        id_sub_category: "",
      },
      itemsCategoria: [],
      itemsSubCategoria: [],
      objEditNow: null,
      snackbar: {
        show: false,
        message: null,
        color: null,
      },
    };
  },
  validations: {
    formObj: {
      name: { required },
      brand: { required },
      price: {
        required: required,
        decimal,
      },
      stock: {
        required: required,
        numeric,
      },
      fileImg: { required },
      id_category: { required },
      id_sub_category: { required },
    },
  },
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("closeDialogEditEvent");
        }
      },
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.formObj.name.$dirty) return errors;
      !this.$v.formObj.name.required && errors.push("Field is required.");
      return errors;
    },
    brandErrors() {
      const errors = [];
      if (!this.$v.formObj.brand.$dirty) return errors;
      !this.$v.formObj.brand.required && errors.push("Field is required.");
      return errors;
    },
    stockErrors() {
      const errors = [];
      if (!this.$v.formObj.stock.$dirty) return errors;
      !this.$v.formObj.stock.required && errors.push("Field is required.");
      return errors;
    },

    priceErrors() {
      const errors = [];
      if (!this.$v.formObj.price.$dirty) return errors;
      !this.$v.formObj.price.required && errors.push("Field is required.");

      if (!this.$v.formObj.price.$dirty) return errors;
      !this.$v.formObj.price.decimal && errors.push("Field is numeric only.");

      return errors;
    },
    fileImgErrors() {
      const errors = [];
      if (!this.$v.formObj.fileImg.$dirty) return errors;
      !this.$v.formObj.fileImg.required && errors.push("Field is required.");
      return errors;
    },
    categoryErrors() {
      const errors = [];
      if (!this.$v.formObj.id_category.$dirty) return errors;
      !this.$v.formObj.id_category.required &&
        errors.push("Field is required.");
      return errors;
    },
    subCategoryErrors() {
      const errors = [];
      if (!this.$v.formObj.id_sub_category.$dirty) return errors;
      !this.$v.formObj.id_sub_category.required &&
        errors.push("Field is required.");
      return errors;
    },

    computedDateFormatted() {
      return this.formatDate(this.formObj.session_date);
    },
    getId() {
      return this.$store.getters.getCurrentCredentials.id;
    },
  },
  created() {},
  watch: {
    "formObj.fileImg": {
      immediate: false,
      handler(e) {
        if (e == undefined) {
          this.imgProfileView = null;
        } else {
          const file = this.formObj.fileImg;
          this.imgProfileView = URL.createObjectURL(file);
        }
      },
    },
    "formObj.id_category": {
      immediate: false,
      handler(e) {
        this.loadSubCategory(e.id);
      },
    },
    objEdit: {
      immediate: true,
      handler(obj) {
        this.objEditNow = obj;
      },
    },
    show(value) {
      if (value === true) {
        this.formObj.name = "";
        this.formObj.brand = "";
        this.formObj.price = "";
        this.formObj.stock = "";
        this.formObj.fileImg = "";
        this.formObj.descrition = "";
        this.formObj.id_sub_category = "";
        this.formObj.id_category = "";

        const obj = this.objEditNow;
        const that = this;

        Vue.nextTick(async function() {
          that.formObj.id = obj.id;
          that.formObj.name = obj.name;
          that.formObj.brand = obj.brand;
          that.formObj.price = obj.price;
          that.formObj.stock = obj.stock;
          that.formObj.descrition = obj.description;

          that.formObj.id_category = obj.id_category;

          await that.loadSubCategory(obj.id_category);

          var objSubCategory = {
            id: obj.id_sub_category,
            name: obj.name_sub_category,
          };

          that.formObj.id_sub_category = objSubCategory;

          //----------imagen de perfil -----------------

          var url = obj.photo;

          url += "?" + new Date().getTime(); // this line of code made magic.

          var dt = new DataTransfer(); // create virtual DataTransfer object
          var request = new XMLHttpRequest(); // create the HTTP request
          request.open("GET", url, true);

          request.responseType = "arraybuffer";
          // with images this works. For other types you'll find an answer yourself eventually :)
          var fileType = url.substr(url.lastIndexOf(".") + 1);
          var mimeType = ("image/" + fileType).replace("jpg", "jpeg"); // there is no MIME type image/jpg only image/jpeg
          request.overrideMimeType(mimeType); // idk if this is necessary but it works
          request.onload = function(e) {
            var blob = new Blob([this.response], { type: mimeType }); // create Blob object from response
            var file = new File([blob], "img Portada.png"); // create File object from Blob
            dt.items.add(file); // add file to virtual DataTransfer
            that.formObj.fileImg = file;
          };
          request.send(); // execute request

          that.imgProfileView = obj.img_path;
        });
      }
    },
  },
  mounted() {
    this.loadCategory();
  },
  methods: {
    async loadSubCategory(id_categoria) {
      await this.$axios
        .get("/api/sub-category/" + id_categoria)
        .then((response) => {
          this.itemsSubCategoria = response.data.data;
        })
        .catch((error) => {});
    },
    loadCategory() {
      this.$axios
        .get("/api/category")
        .then((response) => {
          this.itemsCategoria = response.data.data;
        })
        .catch((error) => {});
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
      } else {
        this.isLoading = true;

        let formData = new FormData();

        formData.append(
          "files",
          this.formObj.fileImg,
          this.formObj.fileImg.name
        );

        //additional data
        formData.append("id", this.formObj.id);
        formData.append("name", this.formObj.name);
        formData.append("brand", this.formObj.brand);
        formData.append("price", parseFloat(this.formObj.price));
        formData.append("stock", parseInt(this.formObj.stock));
        formData.append("description", this.formObj.descrition);

        formData.append("id_sub_category", this.formObj.id_sub_category.id);

        formData.append("user_id", this.getId);

        this.$axios
          .put("/api/editProduct", formData)
          .then((response) => {
            this.$toast.success("Producto Actualizado", "");
            this.isLoading = false;
            this.show = false;
            this.$emit("updateProducts");
            this.formObj.id = "";
          })
          .catch((error) => {
            this.$swal.fire("Error al crear e  producto", error, "error");
            this.isLoading = false;
          });
      }
    },
    inputSoloNumero(event) {
      event.target.value = event.target.value.replace(/[^0-9]/, "");
    },
    inputSoloNumeroDecimal(event) {
      event.target.value = event.target.value.replace(/[^0-9.]/, "");
    },
  },
};
</script>

<style></style>
